import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export const authFieldSx = {
  '& .MuiInputLabel-root': {
    color: 'rgba(168, 214, 244, 0.82)',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#7be4ff',
  },
  '& .MuiOutlinedInput-root': {
    color: '#eef8ff',
    borderRadius: 2.5,
    bgcolor: 'rgba(7, 18, 31, 0.88)',
    '& fieldset': {
      borderColor: 'rgba(93, 157, 219, 0.22)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(123, 228, 255, 0.38)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#58cfff',
      boxShadow: '0 0 0 3px rgba(60, 178, 255, 0.08)',
    },
  },
  '& .MuiFormHelperText-root': {
    color: 'rgba(167, 208, 237, 0.64)',
  },
};

export const authPrimaryButtonSx = {
  py: 1.35,
  borderRadius: 999,
  fontWeight: 800,
  letterSpacing: '0.03em',
  color: '#04111c',
  background: 'linear-gradient(135deg, #77fbff, #2f96ff)',
  boxShadow: '0 18px 32px rgba(47, 150, 255, 0.22)',
  '&:hover': {
    background: 'linear-gradient(135deg, #9bfeff, #4ca8ff)',
  },
};

export const authSecondaryButtonSx = {
  py: 1.05,
  borderRadius: 999,
  color: '#8fd8ff',
  borderColor: 'rgba(104, 181, 243, 0.24)',
  bgcolor: 'rgba(8, 19, 33, 0.38)',
  '&:hover': {
    borderColor: 'rgba(123, 228, 255, 0.4)',
    bgcolor: 'rgba(11, 27, 46, 0.55)',
  },
};

export const authAlertSx = {
  color: '#eef8ff',
  bgcolor: 'rgba(13, 31, 52, 0.82)',
  border: '1px solid rgba(100, 171, 255, 0.18)',
};

function AuthShell({ eyebrow, title, description, sideTitle, sideBody, children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: { xs: 2, sm: 3 },
        py: { xs: 3, sm: 4 },
        color: '#eef8ff',
        fontFamily: '"Avenir Next", "Yu Gothic", "Hiragino Sans", sans-serif',
        background:
          'radial-gradient(circle at 14% 0%, rgba(43,132,255,0.22), transparent 28%), radial-gradient(circle at 88% 12%, rgba(50,255,226,0.14), transparent 24%), linear-gradient(180deg, #02060d 0%, #07111d 46%, #03070f 100%)',
      }}
    >
      <Paper
        sx={{
          width: '100%',
          maxWidth: 1080,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1.05fr) minmax(300px, 0.85fr)' },
          overflow: 'hidden',
          borderRadius: 4,
          color: 'inherit',
          border: '1px solid rgba(92, 160, 219, 0.2)',
          background: 'linear-gradient(180deg, rgba(10,24,41,0.94), rgba(4,10,20,0.96))',
          boxShadow: '0 24px 60px rgba(0, 0, 0, 0.34)',
        }}
      >
        <Stack spacing={3} sx={{ p: { xs: 3, sm: 4.5 } }}>
          <Box>
            <Typography
              sx={{
                color: '#71dbff',
                fontSize: 12,
                letterSpacing: '0.24em',
                textTransform: 'uppercase',
              }}
            >
              {eyebrow}
            </Typography>
            <Typography sx={{ mt: 1.2, fontSize: { xs: 28, sm: 34 }, fontWeight: 800 }}>
              {title}
            </Typography>
            <Typography sx={{ mt: 1.25, color: 'rgba(205, 232, 249, 0.72)', lineHeight: 1.7 }}>
              {description}
            </Typography>
          </Box>
          {children}
        </Stack>

        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            justifyContent: 'space-between',
            p: 4,
            borderLeft: '1px solid rgba(92, 160, 219, 0.12)',
            background:
              'radial-gradient(circle at 20% 0%, rgba(66, 196, 255, 0.12), transparent 32%), linear-gradient(180deg, rgba(7,18,31,0.88), rgba(4,10,20,0.95))',
          }}
        >
          <Box>
            <Typography
              sx={{
                color: '#71dbff',
                fontSize: 12,
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
              }}
            >
              ちりり競馬
            </Typography>
            <Typography sx={{ mt: 1.1, fontSize: 24, fontWeight: 800 }}>{sideTitle}</Typography>
            <Typography sx={{ mt: 1.2, color: 'rgba(205, 232, 249, 0.7)', lineHeight: 1.8 }}>
              {sideBody}
            </Typography>
          </Box>

          <Stack spacing={1.25}>
            {['Secure Session', 'Protected API', 'AI Dashboard Ready'].map((label) => (
              <Box
                key={label}
                sx={{
                  px: 2,
                  py: 1.5,
                  borderRadius: 3,
                  border: '1px solid rgba(96, 241, 255, 0.12)',
                  background: 'linear-gradient(180deg, rgba(12,31,52,0.88), rgba(7,18,33,0.9))',
                }}
              >
                <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
              </Box>
            ))}
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
}

export default AuthShell;
